export default "/_next/static/data/the-omnichannel-success.json-6cab4239644f5c94fd97e67d3d77f089.json";